import React from 'react'
import PropTypes from 'prop-types'

import { Box } from '@chatterbug/aaron'

const TopicDetailSkeleton = ({ topicSection, listSection }) => (
  <Box as="section">
    {topicSection}
    <Box as="section" mt={{ _: '6x', tablet: '88px' }}>
      {listSection}
    </Box>
  </Box>
)

TopicDetailSkeleton.propTypes = {
  topicSection: PropTypes.any,
  listSection: PropTypes.any,
}

export default TopicDetailSkeleton
